/**
 * This should correspond to the Java enum au.com.finsyn.acuritywebserver.core.config.FrontendLogLevel
 */
export enum FrontendLogLevel {
	TRACE = 'TRACE',
	DEBUG = 'DEBUG',
	LOG = 'LOG',
	WARN = 'WARN',
	ERROR = 'ERROR',
}
